import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { Switch, withRouter } from 'react-router';
import RepiSearch from './repiSearch';
import RepiReport from './repiReport';
import PrivateRoute from '../privateRoute';
import RepiSearchResults from './repiSearchResults';
import RepiAddSubjectForm from './repiSections/dataCorrection/repiAddSubjectForm';
import RepiAddContractForm from './repiSections/dataCorrection/repiAddContractForm';

import './repi.scss';

class RepiLandingPage extends React.Component {
    render() {
        return (
            <div className="repi-root">
                <div className="content-root content-root-wide">
                    <Switch>
                        <PrivateRoute exact path={`${this.props.match.url}/search`} component={RepiSearch} />
                        <PrivateRoute exact path={`${this.props.match.url}/results`} component={RepiSearchResults} />
                        <PrivateRoute exact path={`${this.props.match.url}/report/:reportType/:id`} component={RepiReport} />
                        <PrivateRoute exact path={`${this.props.match.url}/add-subject`} component={RepiAddSubjectForm} />
                        <PrivateRoute exact path={`${this.props.match.url}/add-contract/:id`} component={RepiAddContractForm} />
                    </Switch>
                </div>
            </div>
        )
    }
}

export default withLocalize(withRouter(RepiLandingPage));
